var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import fetch from 'cross-fetch';
import { formatUnits } from '@ethersproject/units';
import { BigNumber } from '@ethersproject/bignumber';
export var author = 'mccallofthewild';
export var version = '0.1.0';
export function strategy() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return __awaiter(this, void 0, void 0, function () {
        var space, network, provider, addresses, options, snapshot, _a, coeff, _b, dfuseApiKey, receivingAddresses, contractAddress, decimals, loadJWT, edges, _c, _d, _e, _f, _g, matchingLogs, txLogs, scores, _loop_1, _h, addresses_1, address;
        var _j, _k, _l, _m;
        var _this = this;
        return __generator(this, function (_o) {
            switch (_o.label) {
                case 0:
                    space = args[0], network = args[1], provider = args[2], addresses = args[3], options = args[4], snapshot = args[5];
                    _a = options.coeff, coeff = _a === void 0 ? 1 : _a, _b = options.dfuseApiKey, dfuseApiKey = _b === void 0 ? 'server_806bdc9bb370dad11ec5807e82e57fa0' : _b, receivingAddresses = options.receivingAddresses, contractAddress = options.contractAddress, decimals = options.decimals;
                    loadJWT = function (dfuseApiKey) { return __awaiter(_this, void 0, Promise, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, fetch('https://auth.dfuse.io/v1/auth/issue', {
                                    method: 'POST',
                                    headers: {
                                        Accept: 'application/json',
                                        'Content-Type': 'application/json'
                                    },
                                    body: JSON.stringify({ api_key: dfuseApiKey })
                                })
                                    .then(function (r) { return r.json(); })
                                    .then(function (r) { return r.token; })];
                        });
                    }); };
                    _c = fetch;
                    _d = ['https://mainnet.eth.dfuse.io/graphql'];
                    _j = {
                        method: 'POST'
                    };
                    _k = {
                        Accept: 'application/json',
                        'Content-Type': 'application/json'
                    };
                    _e = "Bearer ";
                    return [4 /*yield*/, loadJWT(dfuseApiKey)];
                case 1:
                    _j.headers = (_k.Authorization = _e + (_o.sent()),
                        _k);
                    _g = (_f = JSON).stringify;
                    _l = {
                        query: /* GraphQL */ "\n        query(\n          $query: String!\n          $sort: SORT\n          $low: Int64\n          $high: Int64\n          $limit: Int64\n        ) {\n          searchTransactions(\n            indexName: LOGS\n            query: $query\n            sort: $sort\n            lowBlockNum: $low\n            highBlockNum: $high\n            limit: $limit\n          ) {\n            edges {\n              node {\n                matchingLogs {\n                  topics\n                  data\n                }\n              }\n            }\n          }\n        }\n      "
                    };
                    _m = {
                        query: "address: '" + contractAddress + "' topic.0:'Transfer(address,address,uint256)' (" + addresses
                            .map(function (a) { return "topic.1:'" + a + "'"; })
                            .join(' OR ') + ") (" + receivingAddresses
                            .map(function (a) { return "topic.2:'" + a + "'"; })
                            .join(' OR ') + ")",
                        sort: 'ASC',
                        limit: 0
                    };
                    return [4 /*yield*/, provider.getBlockNumber()];
                case 2: return [4 /*yield*/, _c.apply(void 0, _d.concat([(_j.body = _g.apply(_f, [(_l.variables = (_m.high = _o.sent(),
                                _m),
                                _l)]),
                            _j)]))
                        .then(function (r) { return __awaiter(_this, void 0, void 0, function () {
                        var json;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, r.json()];
                                case 1:
                                    json = _a.sent();
                                    if (json.errors)
                                        throw json.errors;
                                    return [2 /*return*/, json];
                            }
                        });
                    }); })
                        .catch(function (e) {
                        console.error(e);
                        throw new Error('Strategy ERC20-Received: Dfuse Query Failed');
                    })];
                case 3:
                    edges = (_o.sent()).data.searchTransactions.edges;
                    matchingLogs = edges.reduce(function (prev, edge) { return __spreadArray(__spreadArray([], prev), edge.node.matchingLogs); }, []);
                    txLogs = matchingLogs.map(function (log) {
                        var _a = log.topics.map(function (t) {
                            return t.replace('0x000000000000000000000000', '0x');
                        }), from = _a[1], to = _a[2];
                        var amount = BigNumber.from(log.data);
                        return {
                            from: from,
                            to: to,
                            amount: amount
                        };
                    });
                    scores = {};
                    _loop_1 = function (address) {
                        var logsWithAddress = txLogs.filter(function (log) {
                            var validAddress = log.from.toLowerCase() == address.toLowerCase();
                            return validAddress;
                        });
                        // Sum of all transfers
                        scores[address] = logsWithAddress.reduce(function (prev, curr) {
                            return (prev +
                                parseFloat(formatUnits(curr.amount, BigNumber.from(decimals))) * coeff);
                        }, 0);
                    };
                    for (_h = 0, addresses_1 = addresses; _h < addresses_1.length; _h++) {
                        address = addresses_1[_h];
                        _loop_1(address);
                    }
                    return [2 /*return*/, scores];
            }
        });
    });
}
